/// <amd-module name="Test/TestPlansHubRefresh/SuitesMenu/SuitesMenuConstants" />
export const AssignConfigToSuiteDialog = "AssignConfigToSuite";
